<template>
  <sqr-modal @close="$emit('close')">
    <h1 class="font-semibold text-md text-gray-800 mb-3">
      {{ $t('issuer_select_modal_title') }}
    </h1>
    <div class="flex space-x-2 mb-6">
      <router-link
        :to="{
          name: 'issuer-add',
          query: { update: 'invoice', updateId: invoiceId }
        }"
      >
        <sqr-button :label="$t('invoice_issuer_add')" color="primary">
          <template slot="icon">
            <UserAddIcon class="inline w-4 h-4 stroke-current" />
          </template>
        </sqr-button>
      </router-link>
      <router-link
        :to="{
          name: 'invoice-issuer',
          params: { id: invoiceId },
          query: { validation }
        }"
      >
        <sqr-button :label="$t('invoice_issuer_edit')" color="light">
          <template slot="icon">
            <PencilIcon class="inline w-4 h-4 stroke-current" />
          </template>
        </sqr-button>
      </router-link>
      <div class="text-xs text-red-600" v-if="validation">
        {{ $t('validation_general') }}
      </div>
    </div>
    <h2 class="font-lg font-medium text-gray-700 mb-3">
      {{ $t('issuer_select_modal_choose') }}
    </h2>
    <sqr-progress color="primary" v-show="loading" />
    <div class="">
      <ul class="" v-for="issuer in issuers" :key="issuer.id">
        <li class="hover:bg-blue-50 px-4 py-1 border-t cursor-pointer">
          <a @click="select(issuer)">
            <span class="has-text-weight-semibold">{{ issuer.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </sqr-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import SqrModal from '@/components/SqrModal';
import SqrProgress from '@/components/SqrProgress';
import SqrButton from '@/components/SqrButton';
import { PencilIcon, UserAddIcon } from '@vue-hero-icons/outline';
export default {
  name: 'IssuerSelectModal',
  components: {
    SqrModal,
    SqrProgress,
    SqrButton,
    UserAddIcon,
    PencilIcon
  },
  props: {
    invoiceId: { type: String },
    validation: { type: Boolean }
  },
  computed: {
    ...mapGetters('account', ['issuers', 'loading'])
  },
  methods: {
    select(issuer) {
      this.$emit('selected', issuer);
    }
  }
};
</script>
